module.exports = __webpack_public_path__ + "static/media/quote-schwartz-feelvalued-fr.89102145.png";